export default "__VITE_ASSET__DQvpb5fg__"